module.exports = __webpack_public_path__ + "static/img/twin-highway-4.0c5eeef8.png";